var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:{
    disabled: _vm.disabled || _vm.loading,
    block: _vm.block,
    small: _vm.size === 'small',
    'type-primary': _vm.type === 'primary'
  },style:({ 'min-width': _vm.width ? _vm.width : '' }),attrs:{"disabled":_vm.disabled || _vm.loading},on:{"click":_vm.click}},[(_vm.loading)?_c('a-icon',{staticClass:"mr-1x",attrs:{"type":"loading"}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }